import React, { useEffect } from 'react'
import { VideoEl } from '../Elements'
import VideoRecordStore from '../Stores/VideoRecordStore'
import RecorderOptions from './RecorderOptions'

function Recorder({ maxDuration }) {
  const {
    recordingState,
    videoPlayer,
    stopVid,
  } = VideoRecordStore.useContainer()

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => stopVid.current()
  }, [stopVid])

  return (
    <VideoEl state={recordingState}>
      <div className='camera'>
        <video ref={videoPlayer} autoPlay />
      </div>
      <RecorderOptions maxDuration={maxDuration} />
    </VideoEl>
  )
}

export default Recorder
